<template>
  <div class="body">
    <divider/>
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        基本信息
      </div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="tableLabel">编号</td>
          <td class="tdContent">{{deliveryNotice.billNo}}</td>
          <td class="tableLabel">客户名称</td>
          <td class="tdContent" colspan="3">{{deliveryNotice.customerName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">发货地址</td>
          <td class="tdContent">{{deliveryNotice.deliveryAddress}}</td>
          <td class="tableLabel">联系人</td>
          <td class="tdContent">{{deliveryNotice.deliveryContact}}</td>
          <td class="tableLabel">联系方式</td>
          <td class="tdContent">{{deliveryNotice.deliveryTel}}</td>
        </tr>
        <tr>
          <td class="tableLabel">状态</td>
          <td class="tdContent">{{deliveryNotice.statusName}}</td>
          <td class="tableLabel">制单人</td>
          <td class="tdContent">{{deliveryNotice.creatorName}}</td>
          <td class="tableLabel">制单时间</td>
          <td class="tdContent">{{deliveryNotice.createTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">备注</td>
          <td class="tdContent" colspan="5">{{deliveryNotice.note}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div style="border-bottom: 1px solid #ddd;
            margin-bottom: 10px;
            padding-bottom: 5px;
            font-size: 16px;
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;">
        <div>发货明细</div>
        <!--        <div v-if="salesOrder.totalAmount !== 0">总金额：￥{{salesOrder.totalAmount}}</div>-->
        <!--        <div v-else>总金额：￥0</div>-->
      </div>
      <el-table ref="payData" border :data="deliveryNotice.deliveryBillDetails">
        <el-table-column label="销售订单" prop="salesOrderNO" align="center" width="110"/>
        <el-table-column label="物料编号" prop="materialNo" align="center" width="160"/>
        <el-table-column label="物料名称" prop="materialName" align="center" width="150"/>
        <el-table-column label="销单数量" prop="salesOrderQuantity" align="center" width="100"/>
        <el-table-column label="已发数量" prop="shippedQuantity" align="center" width="80"/>
        <el-table-column label="发货数量" prop="quantity" align="center" width="100"/>
        <el-table-column label="交货日期" prop="deliveryDate" align="center" width="160"/>
        <el-table-column label="单价" prop="price" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.price !== null">{{scope.row.price}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="note" align="center" width="280"/>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constant from "@/util/constant";

  export default {
    name: "DeliveryNotePreview",
    components: {HandleDetail},
    props: {
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        billId: "",
        billType: "",
        sequId: "",
        constant,
        deliveryPlace: "", // 收货地址
        nodeId: "",
        isHidden: false,
        deliveryNotice: {},
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(val) {
          if (val.query.billId) {
            this.billId = val.query.billId;
            this.billType = val.query.billType;
            this.sequId = val.query.sequId;
            this.getData(val.query.billId);
            this.getNodeValue();
          }
        },
      },
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    methods: {
      getData() {
        this.$http.get("basic", `sd/DeliveryBills/${this.billId}`).then(res => {
          if (res.success) {
            this.deliveryNotice = res.data;
            // this.getSalesOrderDetail();
          }
        });
      },

      //获取省市区id获取三级联动
      getDeliveryPlace(id) {
        if (id > 0) {
          this.$http.get("basic", `districts/cascadename/${id}`).then((resp) => {
            console.log(resp);
            if (resp.success) {
              this.deliveryPlace = resp.data + "," + this.salesOrder.deliveryPlace;
            }
          });
        }
      },

      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      getNodeValue() {
        let params = {
          billType: this.billType,
          billId: this.billId,
          sequId: this.sequId,
        };
        this.$http.get("basic", "applications/approve", params).then((resp) => {
          this.nodeId = resp.data.nodeId;
        });
      },

      doApprove() {
        let billParam = [];
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          billParam: JSON.stringify(billParam),
        };
        console.log(params);
        this.$emit("loading-status", {loading: true});
        this.$http
            .post("basic", "applications/doApprove", params)
            .then((resp) => {
              this.$emit("loading-status", {loading: false});
              if (resp.success) {
                this.$message.success("保存成功");
                // 关闭标签
                this.$bus.$emit("closeTag", this.$route);
                this.$router.push({
                  path: "/workFlow/DeliveryNoteApplication",
                });
              }
            })
            .catch(() => {
              this.$emit("loading-status", {loading: false});
            });
      },
    },
  };
</script>
<style lang="scss">
.body {
  .el-button + .el-button {
    margin-left: 0;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 10px;
  }

  .body-btn {
    margin-bottom: 2px;
    margin-right: 2px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
    width: 100%;
  }

  table.gridtable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    background-color: #D1E6F5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
}
</style>
